import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { HFService } from '@services/hf.service';
import { SearchService } from '@services/search.service';
import { SetDeviceInit } from '@store/context/context.actions';
import {
  selectContextCore,
  selectContextLanding,
  selectDeviceIsMobile,
} from '@store/context/context.selector';
import { IContextCore } from '@store/context/context.state';
import { IHotelsAppState } from '@store/index';
import { selectInitialSearchData } from '@store/search/search.selector';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { TrivagoService } from '@services/trivago.service';
import { SearchBoxComponent } from '@am/search-box';
import { SearchBoxSummaryComponent } from './commons/searchbox-summary/searchbox-summary.component';
import { AsyncPipe } from '@angular/common';
import { SearchBoxSkeletonComponent } from './commons/searchbox-skeleton/searchbox-skeleton.component';
import { MbProgressBar } from '@am/moebius';

@Component({
  selector: 'am-root',
  standalone: true,
  styleUrls: ['./app.component.scss'],
  templateUrl: './app.component.html',
  imports: [
    MbProgressBar,
    SearchBoxSkeletonComponent,
    SearchBoxSummaryComponent,
    SearchBoxComponent,
    RouterOutlet,
    AsyncPipe,
  ],
})
export class AppComponent implements OnInit {
  public initialData$: Observable<any>;
  public context$: Observable<IContextCore>;
  public isMobile$: Observable<boolean>;
  public isLanding$: Observable<boolean>;

  constructor(
    private hfService: HFService,
    private searchService: SearchService,
    private store$: Store<IHotelsAppState>,
    private router: Router,
    // @ts-expect-error TrivagoService is injected but not directly used in constructor logic or TS thinks it's undefined
    private readonly trivagoService: TrivagoService,
  ) {}

  public ngOnInit(): void {
    this.initialize();
    this.context$ = this.store$.pipe(select(selectContextCore));
  }

  public initialize() {
    this.store$.dispatch(new SetDeviceInit());
    this.hfService.showHeaderFooter();
    this.showSearchBox();
    this.setIsLanding();
  }

  public showSearchBox() {
    this.initialData$ = this.store$.pipe(
      select(selectInitialSearchData),
      filter((data) => data !== undefined),
      map((data) => this.searchService.prepareSearchInfo(data)),
    );
    this.initialData$.subscribe((response: any) => {
      console.log(response);
    });
    this.isMobile$ = this.store$.pipe(select(selectDeviceIsMobile));
  }

  public handleSearch(data) {
    if (this.searchService.searchValidator(data)) {
      this.searchService
        .prepareNavigationData(data)
        .subscribe((uri) => {
          if (uri) {
            this.router.navigate([uri.path], {
              queryParams: uri.params,
            });
          }
        })
        .unsubscribe();
    }
  }

  private setIsLanding() {
    this.isLanding$ = this.store$.pipe(select(selectContextLanding));
  }
}
